import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';

export function getParticipantState(participant: {
  transitions?: { state?: ParticipantState }[];
}) {
  return participant?.transitions?.[0]?.state;
}
